export default "__VITE_ASSET__Dy8DrKtq__"